module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10192.da7aedc1.jpg";